// src/components/MapChart.js
import React, { useEffect, useRef, useState } from 'react'
import Highcharts from 'highcharts/highmaps'
import HighchartsReact from 'highcharts-react-official'
import mapDataWorld from './euro.geo.json'
import { Card, CardContent, Skeleton } from '@mui/material'

export const MapChart = ({ data }) => {
    const chart = useRef()

    const [options, setOptions] = useState(null)

    useEffect(() => {
        let _data = {}
        data?.map((el) => {
            if (_data[el]) {
                _data[el] += 1
            } else {
                _data[el] = 1
            }
        })
        let _chartData = Object.entries(_data).map(([code, value]) => ({
            code,
            value,
            name: code,
        }))

        let _mapData = { ...mapDataWorld }
        _mapData.features = _mapData.features.filter((el) => _data?.[el?.id])

        setOptions({
            chart: {
                map: 'custom/world',
            },
            title: {
                text: 'Répartition des actifs',
            },
            mapNavigation: {
                enabled: true,
                enableMouseWheelZoom: false,
            },
            colorAxis: {
                min: 0,
            },
            zoomBy: 2,
            series: [
                {
                    name: 'Hotels',
                    mapData: _mapData,
                    data: _chartData,
                    joinBy: ['iso-a2', 'code'],
                    states: {
                        hover: {
                            color: '#BADA55',
                        },
                    },
                    dataLabels: {
                        enabled: true,
                        format: '{point.name}',
                    },
                },
            ],
        })
    }, [data])

    if (!options) return <Skeleton />

    return (
        <Card>
            <CardContent>
                <HighchartsReact
                    highcharts={Highcharts}
                    constructorType={'mapChart'}
                    options={options}
                    ref={chart}
                    immutable={true}
                />
            </CardContent>
        </Card>
    )
}
